import { AbstractControl, Validators } from '@angular/forms';
import { CustomSelectValidator } from './custom-select.validator';

export class CustomPayMethodsValidator {

    static PayMethodCorrect(group: AbstractControl) {
        if (!group.get("withCredit").value) {
            group.get("cardHolderName").setErrors(null);
            group.get("cardNumber").setErrors(null);
            group.get("dates").get("cardExpiryMonth").setErrors(null);
            group.get("dates").get("cardExpiryYear").setErrors(null);
            group.get("cardCvc").setErrors(null);
            group.setErrors(null);
            return null;
        }
    }
    static CreditCardCorrect(group: AbstractControl){
        group.get("cardHolderName").setValidators([Validators.required,Validators.pattern('^([^0-9]*)$')]);
        group.get("cardNumber").setValidators(Validators.required);
        group.get("dates").get("cardExpiryMonth").setValidators(CustomSelectValidator.required);
        group.get("dates").get("cardExpiryYear").setValidators(CustomSelectValidator.required);
        group.get("cardCvc").setValidators([Validators.pattern('^[0-9]{3,4}$')]);
    }
    
}